import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {SectionComponent} from '../../elements/section/section.component';
import {MainBestHotelsComponent} from '../main/items/main-best-hotels/main-best-hotels.component';
import {Continent,} from '../../../model/circle';
import {Card,} from '../../../model/cards';
import {HeaderService} from '../../../services/header-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AdventuresService} from '../../../services/adventures-service';
import {LocationDto} from '../../../model/continent';
import {PaginationParams} from '../../../model/pagination';
import {environment} from '../../../environments/environment';
import {NgIf} from '@angular/common';
import {MenuService} from '../../../services/menu-services';
import {LoadingService} from '../../../services/loading-service';
import {Subscription, finalize, timeout} from 'rxjs';
import {TextsComponent} from '../../elements/texts/texts.component';

@Component({
  selector: 'app-adventures-page',
  imports: [
    SectionComponent,
    MainBestHotelsComponent,
    NgIf,
    TextsComponent,
  ],
  templateUrl: './adventures-page.component.html',
  standalone: true,
  styleUrl: './adventures-page.component.scss'
})
export class AdventuresPageComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(protected interfaceService: HeaderService,
              private route: ActivatedRoute,
              private router: Router,
              private adventuresService: AdventuresService,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {
  }

  adventures: LocationDto[] = [];

  paramsList: PaginationParams = new PaginationParams({
    query: '',
    pageSize: 1000,
    pageNumber: 0,
    sort: '',
  });

  cards: Card[] = [];

  loading: boolean = false;
  loadError = false;
  private request?: Subscription;

  ngOnInit() {
    this.loadingService.setLoadingValue(false);
    this.menuService.setMobileSpecialStyle(true);
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    this.loadAdventures();
  }

  loadAdventures() {
    this.request?.unsubscribe();
    this.loading = true;
    this.loadError = false;
    this.request = this.adventuresService.getAdventureList(this.paramsList).pipe(
      timeout(12000),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe({
      next: (data) => {
        this.adventures = data.content?.map(v => new LocationDto(v)) ?? [];
        this.cards = this.adventures.map((v) => new Card({
          id: v.id,
          title: ['', ''],
          text: [v.titleRu, v.titleEn],
          img: v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/typesTravel/beach1.jpeg',
          style: this.getFilter(v.cssStyleImage ?? ''),
          button: false,
          link: 'adventures/' + v.url,
        }));
      }, error: () => {
        this.loadError = true;
      }
    });
  }

  getFilter(str: string): string {
    const match = str.match(/grayscale\(([\d.]+)%\)/);
    if (match && match[1]) {
      return match[1];
    }
    return "0";
  }

  ngAfterViewInit() {
    this.interfaceService.setPageInterface('header-container-white');
  }

  ngOnDestroy() {
    this.request?.unsubscribe();
    this.loadingService.setLoadingValue(false);
    this.menuService.setMobileSpecialStyle(false);
    this.interfaceService.setHeaderStyle(false);
  }

  goToDestination(continent: Continent) {
    const url = '/destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url], {relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

}
